import React from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerDataMission } from '../../../data/modules/mission-header';
import DecompteTable from './DecompteTable';

const Decompte = () => {
  return (
    <MainContainer {...headerDataMission}>
      <DecompteTable />
    </MainContainer>
  );
};

export default Decompte;